import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'


import {
  SAVE_PARAMS_NEXP_REQUEST,
  SAVE_PARAMS_NEXP_REQUEST_ERROR,
  SAVE_PARAMS_NEXP_REQUEST_SUCCESS,
  FETCH_PARAMS_NEXP_REQUEST,
  FETCH_PARAMS_NEXP_REQUEST_SUCCESS,
  FETCH_PARAMS_NEXP_REQUEST_ERROR,
  FETCH_SECTIONS_DEFAULT
} from 'actionTypes'

export const fetchSections = (token, params) => (dispatch) => {
  dispatch(fetchSectionsRequest())
  return new Api(token, dispatch)
    .post(`${API_URL.FIND_PARAMS_NEXP}?size=1&page=1`, params)
    .then(dispatch(showSpinner()))
    .then(async (response) => {
      dispatch(fetchSectionsSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchSectionsError(error))
      dispatch(hideSpinner())
    })
}

export const resetParamsNexp = () => (dispatch) => {
  dispatch(fetchSectionsDefault())
}

export const fetchSectionsDefault = () => ({
  type: FETCH_SECTIONS_DEFAULT
})

export const fetchSectionsRequest = () => ({
  type: FETCH_PARAMS_NEXP_REQUEST,
})


export const fetchSectionsSuccess = (data) => ({
  type: FETCH_PARAMS_NEXP_REQUEST_SUCCESS,
  payload: data,
})

export const fetchSectionsError = (error) => ({
  type: FETCH_PARAMS_NEXP_REQUEST_ERROR,
  payload: error,
})

export const updateNexp = (token, args, callBack) => (dispatch) => {
  dispatch(updateNexpRequest())

  return new Api(token, dispatch)
    .post(API_URL.SAVE_PARAMS_NEXP, args)
    .then(dispatch(showSpinner()))
    .then((response) => {
      /* istanbul ignore else */
      if (callBack) {
        callBack()
      }
      dispatch(updateNexpSuccess(response.data))
      dispatch(hideSpinner())

      return response
    })
    .catch((error) => {
      dispatch(updateNexpError(error))
      dispatch(hideSpinner())

      return error
    }).finally(() => {

      dispatch(fetchSectionsDefault())
    })
}

export const updateNexpRequest = () => ({
  type: SAVE_PARAMS_NEXP_REQUEST
})

export const updateNexpSuccess = (data) => ({
  type: SAVE_PARAMS_NEXP_REQUEST_SUCCESS,
  payload: data,
})

export const updateNexpError = (error) => ({
  type: SAVE_PARAMS_NEXP_REQUEST_ERROR,
  payload: { error },
})
